import React from "react";
import "./style.css";

export default function InventorySync({ data, handleOnClick }) {
  return (
    <div className="inventory_sync_bg">
      <p className="inventory_sync_head">Inventory Synchronization</p>

      <div className="inventory_sync_option_row">
        <div>
          <label className="modern_toggle">
            <input
              type="checkbox"
              checked={data.inventorySync.amazon}
              onChange={() =>
                handleOnClick(
                  "inventorySync",
                  "amazon",
                  !data.inventorySync.amazon
                )
              }
            />
            <span className="toggle_slider"></span>
          </label>
          <p>Amazon</p>
        </div>

        <div>
          <label className="modern_toggle">
            <input
              type="checkbox"
              checked={data.inventorySync.shopify}
              onChange={() =>
                handleOnClick(
                  "inventorySync",
                  "shopify",
                  !data.inventorySync.shopify
                )
              }
            />
            <span className="toggle_slider"></span>
          </label>
          <p>Shopify</p>
        </div>
      </div>
    </div>
  );
}
